<app-wizard
  *ngIf="wizardSteps"
  [steps]="wizardSteps"
  [startingStep]="1"
  (finish)="onWizardFinish($event)"></app-wizard>
